/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  CreateSizeSetRequest,
  DeleteAdminV1OrgSizeSetsIdPathParameters,
  GetAdminV1OrgSizeSets200,
  GetAdminV1OrgSizeSetsIdPathParameters,
  PatchAdminV1OrgSizeSetsIdPathParameters,
  SizeSet,
  UpdateSizeSetRequest
} from '../model';

import { customInstance } from '../../../transport/mutator';
import type { BodyType } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Size sets of the organization with their values
 */
export const getAdminV1OrgSizeSets = (

 options?: SecondParameter<typeof customInstance<GetAdminV1OrgSizeSets200>>,) => {
      return customInstance<GetAdminV1OrgSizeSets200>(
      {url: `/admin/v1/org/size-sets`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Create a size set with its values
 */
export const postAdminV1OrgSizeSets = (
    createSizeSetRequest: BodyType<CreateSizeSetRequest>,
 options?: SecondParameter<typeof customInstance<SizeSet>>,) => {
      return customInstance<SizeSet>(
      {url: `/admin/v1/org/size-sets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSizeSetRequest
    },
      options);
    }
  /**
 * @summary Get a size set
 */
export const getAdminV1OrgSizeSetsId = (
    { id }: GetAdminV1OrgSizeSetsIdPathParameters,
 options?: SecondParameter<typeof customInstance<SizeSet>>,) => {
      return customInstance<SizeSet>(
      {url: `/admin/v1/org/size-sets/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update a size set. Passing values replaces the whole list.
 */
export const patchAdminV1OrgSizeSetsId = (
    { id }: PatchAdminV1OrgSizeSetsIdPathParameters,
    updateSizeSetRequest: BodyType<UpdateSizeSetRequest>,
 options?: SecondParameter<typeof customInstance<SizeSet>>,) => {
      return customInstance<SizeSet>(
      {url: `/admin/v1/org/size-sets/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSizeSetRequest
    },
      options);
    }
  /**
 * @summary Delete a size set no customization uses
 */
export const deleteAdminV1OrgSizeSetsId = (
    { id }: DeleteAdminV1OrgSizeSetsIdPathParameters,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/v1/org/size-sets/${id}`, method: 'DELETE'
    },
      options);
    }
  export type GetAdminV1OrgSizeSetsResult = NonNullable<Awaited<ReturnType<typeof getAdminV1OrgSizeSets>>>
export type PostAdminV1OrgSizeSetsResult = NonNullable<Awaited<ReturnType<typeof postAdminV1OrgSizeSets>>>
export type GetAdminV1OrgSizeSetsIdResult = NonNullable<Awaited<ReturnType<typeof getAdminV1OrgSizeSetsId>>>
export type PatchAdminV1OrgSizeSetsIdResult = NonNullable<Awaited<ReturnType<typeof patchAdminV1OrgSizeSetsId>>>
export type DeleteAdminV1OrgSizeSetsIdResult = NonNullable<Awaited<ReturnType<typeof deleteAdminV1OrgSizeSetsId>>>
